import React from 'react';
import PropTypes from 'prop-types';

import { cx } from 'utility';
import * as styles from './VideoEmbed.module.scss';

const propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    videoEmbedUrl: PropTypes.string,
};

const defaultProps = {
    className: '',
    title: '',
    videoEmbed: '',
};

function getVideoClasses({ className }) {
    const classes = cx(
        className,
        styles['video'],
    );

    return classes || undefined;
}

function VideoEmbed({
    className,
    title,
    videoEmbedUrl,
}) {
    const classes = getVideoClasses({ className });
    videoEmbedUrl = videoEmbedUrl?.split('src=')[1].split(/[ >]/)[0].slice(1,-1);

    return (
        <div className={classes}>
            <iframe
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen={true}
                className={styles['videoIframe']}
                frameBorder="0"
                loading="lazy"
                mozallowfullscreen="true"
                src={videoEmbedUrl}
                title={title}
                webkitallowfullscreen="true"
            />
        </div>
    );
}

VideoEmbed.propTypes = propTypes;
VideoEmbed.defaultProps = defaultProps;

export { VideoEmbed };
